import Campaign from 'entities/campaign/model';
import User from 'entities/user/model';

export const INIT = 'app/CampaignsPage/INIT';
export const INIT_SUCCESS = 'app/CampaignsPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/CampaignsPage/INIT_FAILED';

export const SET_OPT_IN_STATUS = 'app/CampaignsPage/SET_OPT_IN_STATUS';
export const SET_OPT_IN_STATUS_SUCCESS = 'app/CampaignsPage/SET_OPT_IN_STATUS_SUCCESS';
export const SET_OPT_IN_STATUS_FAILED = 'app/CampaignsPage/SET_OPT_IN_STATUS_FAILED';

export interface InitAction {
  type: typeof INIT;
}

export const initAction = (campaignsType?: string) => ({
  type: INIT,
  campaignsType,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
export const initFailedAction = (error: Error) => ({
  type: INIT_FAILED,
  error,
});

export const setOptInStatusAction = (campaign: Campaign, user: User, optIn: boolean) => ({
  type: SET_OPT_IN_STATUS,
  campaign,
  user,
  optIn,
});
export const setOptInStatusSuccessAction = () => ({
  type: SET_OPT_IN_STATUS_SUCCESS,
});
export const setOptInStatusFailedAction = (error: Error) => ({
  type: SET_OPT_IN_STATUS_FAILED,
  error,
});
